export const GET_SPORTS_START = "GET_SPORTS_START";
export const GET_SPORTS_FINISH = "GET_SPORTS_FINISH";
export const GET_SPORTS_ERROR = "GET_SPORTS_ERROR";
